import { useContext } from 'react'
import { AuthContext } from './AuthContext'

/**
 * Hook for consuming authentication state and actions.
 *
 * Must be used within a component tree wrapped by AuthProvider.
 *
 * Usage:
 *   const { user, isAuthenticated, login, logout } = useAuth()
 */
export function useAuth() {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider')
  }
  return context
}
